(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledDetailController', Queue_scheduledDetailController);

    Queue_scheduledDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Queue_scheduled', 'Qsched_direction', 'Qsched_status', 'Qsched_type'];

    function Queue_scheduledDetailController($scope, $rootScope, $stateParams, previousState, entity, Queue_scheduled, Qsched_direction, Qsched_status, Qsched_type) {
        var vm = this;

        vm.queue_scheduled = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queue_scheduledUpdate', function(event, result) {
            vm.queue_scheduled = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
